import type { IconNode } from 'lucide-react';

/**
 * Serializes a Lucide `IconNode` array (the data shape that `lucide-react`'s
 * per-icon modules export as `__iconNode`) into the inner SVG element string —
 * suitable for injecting into a `<g>` inside a hand-built SVG, for cases where
 * we can't render a React component (e.g. Google Maps marker data URLs).
 *
 * Wrap the returned string in a `<g fill="none" stroke="..." stroke-width="..."
 * stroke-linecap="round" stroke-linejoin="round">` to match Lucide's default
 * rendering attributes — they aren't included in the per-element output.
 */
export function lucideIconNodeToSvg(iconNode: IconNode): string {
  return iconNode
    .map(([tag, attrs]) => {
      const a = Object.entries(attrs)
        .filter(([k]) => k !== 'key')
        .map(([k, v]) => `${k}="${v}"`)
        .join(' ');
      return `<${tag} ${a}/>`;
    })
    .join('');
}
